export default __webpack_public_path__ + "static/media/inuneko_logo_l@3x.24bc58d8.png";